const INSIGHTS_LOADER_TEXT = "Preparing your top insights";

export {
    INSIGHTS_LOADER_TEXT
};
